import * as React from "react";
import { forwardRef } from "react";
const MailSVG = (props, ref) => React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", ref: ref, ...props },
    React.createElement("path", { fillRule: "evenodd", d: "M4.5 6.134A1 1 0 0 1 5 6h14c.182 0 .353.049.5.134l-.03.018L12 10.821 4.53 6.152zM4 8.179V17a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V8.18l-7.47 4.668a1 1 0 0 1-1.06 0zM5 4a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V7a3 3 0 0 0-3-3z", clipRule: "evenodd" }));
const ForwardRef = forwardRef(MailSVG);
export default ForwardRef;
//# sourceMappingURL=Mail.js.map